// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { store } from './store';
import { authApi } from './store/domains/auth';

const excludedPaths = ['/login', '/otp', '/provider'];

if (!excludedPaths.includes(window.location.pathname)) {
  store.dispatch(authApi.endpoints.getMe.initiate());
}

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <Router />
    </ThemeProvider>
  );
}
